import { ICommonCart, ICommonCartDomainItem, ICommonRemoveItemFromCartRequest } from '@cuspar/ywt.ch.model';
import { PriceGadget } from '../UI/PriceGadget';
import { Trash2 } from 'lucide-react';
import { useCartStore } from '../../state/cartStore';
import { Badge } from '@cuspar/ui';
import { useTranslation } from 'react-i18next';

export const CartBannerDomainItem = ({ cart, domainItem }: { cart: ICommonCart; domainItem: ICommonCartDomainItem }) => {
  const { t } = useTranslation();
  const removeItemFromCart = useCartStore((state) => state.removeItemFromCart);

  async function hanndleRemoveDomain() {
    const request: ICommonRemoveItemFromCartRequest = {
      type: 'domain',
      identifier: domainItem.domain,
    };
    removeItemFromCart(cart.id, request);
  }

  return (
    <div className='w-full flex flex-col items-start gap-2 rounded-xs border p-3 text-left text-sm transition-all hover:bg-accent bg-muted mb-3'>
      <div className='flex w-full justify-between items-center'>
        <div className='font-semibold'>
          {t('common.domain')} <Badge className='h-4 ml-1 bg-primary/80'>{domainItem.type}</Badge>
        </div>
        <Trash2 onClick={hanndleRemoveDomain} className='cursor-pointer hover:text-destructive h-4 w-4' />
      </div>
      <div className='flex w-full flex-col gap-1'>
        <div className='flex items-center'>
          <div className='flex items-center gap-2'>
            <div className='text-xs font-medium'>{domainItem.domain}</div>
          </div>
          <div className='ml-auto text-xs text-foreground'>
            <PriceGadget price={domainItem.price} currency={cart.currency} />
          </div>
        </div>
      </div>
    </div>
  );
};
